import { ValidateCheckbox, ValidateNumber, ValidateRadio, ValidateText } from "@/util/ValidationUtil";
import { StationCharger } from "@/model/StationDetail.ts";

export class InspectionSlowChargerDto {
    id: bigint;
    /**
     * 충전기 ID ( 충전소 ID + 충전기 ID )
     */
    @ValidateNumber("충전기ID")
    chargerId: string;
    /**
     * 충전기 용량
     */
    @ValidateNumber("충전기 용량")
    chargerCapacity: number;
    /**
     * 제조사
     */
    @ValidateText("제조사")
    maker: string;
    /**
     * 시리얼 No
     */
    @ValidateText("시리얼No.")
    serialNumber: string;
    /**
     * 모뎀 번호
     */
    @ValidateText("모뎀 번호")
    modemNumber: string;
    /**
     * 커넥터 타입
     * */
    @ValidateText("커넥터 타입")
    connectorType: string;
    /**
     * 충전기 타입
     */
    @ValidateText("충전기 타입")
    chargerType: string;
    /**
     * 모델명
     */
    @ValidateText("모델명")
    modelName: string;
    /**
     * 명판형식인증번호
     */
    @ValidateText("명판형식인증번호")
    modelNameCardNumber: string;
    /**
     * 펌웨어 버전
     */
    @ValidateText("펌웨어 버전")
    firmwareVersion: string;
    /**
     * LCD 타입
     */
    @ValidateText("LCD")
    lcdType: string;
    /**
     * 안드로이드 타입
     */
    @ValidateText("안드로이드")
    androidType: string;
    /**
     * 충전건 제조 회사
     */
    @ValidateText("충전건")
    chargerOutlet: string;
    /**
     * 배선 굵기
     */
    @ValidateText("배선 굵기")
    wireWidth: string;
    /**
     * 설치 방식
     */
    @ValidateText("설치 방식")
    installType: string;
    /**
     * 스토퍼
     */
    @ValidateRadio("스토퍼")
    isStopper: boolean = true;
    /**
     * 볼라드
     */
    @ValidateRadio("볼라드")
    isBollard: boolean = true;
    /**
     * 커넥터 거치대
     */
    @ValidateRadio("커넥터 거치대")
    isConnectorSeat: boolean = true;
    /**
     * 지면에서 충전기 하단까지 높이
     */
    @ValidateNumber("지면에서 충전기 하단까지 높이")
    height: number;
    /**
     * 충전기 상단과 비 가림막이 갭
     */
    @ValidateNumber("충전기 상단과 비 가림막이 갭", false)
    capHeight: number;
    /**
     * 스토퍼와 충전기간 거리상 위험 여부
     */
    @ValidateRadio("스토퍼와 충전기간 거리상 위험 여부")
    isStopperHazard: boolean = true;
    /**
     * 충전기 명판
     */
    @ValidateRadio("충전기 명판")
    isChargerNameCard: boolean = true;
    /**
     * KTC 검정 인증 스티커
     */
    @ValidateRadio("KTC 검정 인증 스티커")
    isKtcSticker: boolean = true;
    /**
     * OCPP 인증번호
     */
    @ValidateRadio("OCPP 인증번호")
    isOcppNumber: boolean = true;
    /**
     * 충전기 연번
     */
    @ValidateRadio("충전기 연번")
    isChargerNumber: boolean = true;
    /**
     * 통합 QR
     */
    @ValidateRadio("통합 QR")
    isQr: boolean = true;
    /**
     * 환경부 불편민원신고센터 스티커
     */
    @ValidateRadio("환경부 불편민원신고센터 스티커")
    isEvSticker: boolean = true;
    /**
     * 이용 안내판
     */
    @ValidateRadio("이용 안내판")
    isGuide: boolean = true;
    /**
     * 충전기 정상 유무
     */
    @ValidateRadio("충전기 정상 유무")
    isChargerStatus: boolean = true;
    /**
     * LCD 필름 제거
     */
    @ValidateRadio("LCD 필름 제거")
    isRemoveFilter: boolean = true;
    /**
     * LCD 파손/불량
     */
    @ValidateRadio("LCD 파손/불량")
    isFaultLcd: boolean = true;
    /**
     * 외관 파손 여부
     */
    @ValidateRadio("외관 파손 여부")
    isFaultOutline: boolean = true;
    /**
     * 모뎀 상태 체크
     */
    @ValidateRadio("모뎀 상태 체크")
    isModemCheck: boolean = true;
    /**
     * LCD 틈새 발생 여부
     */
    @ValidateRadio("LCD 틈새 발생 여부")
    isLcdGap: boolean = true;
    /**
     * 상태 미확인 현장확인 결과
     */
    @ValidateCheckbox("상태 미확인 현장 확인 결과", false)
    unknownChargerReasons: string[];

    constructor(data?: StationCharger) {
        if (data) {
            this.chargerId = data.chargerId;
            this.maker = data.maker;
            this.connectorType = data.connectorType;
            this.chargerCapacity = data.chargerCapacity;
            this.chargerType = data.chargerType;
            this.serialNumber = data.serialNumber;
            this.modemNumber = data.modemNumber;
            this.firmwareVersion = data.firmwareVersion;
            this.wireWidth = data.wireWidth;
            this.modelName = data.modelName;
            this.modelNameCardNumber = data.modelNameCardNumber;
            this.installType = data.installType;
            this.lcdType = data.lcdType;
            this.androidType = data.androidType;
            this.chargerOutlet = data.chargerOutlet;
        }
    }
}